import React, { useCallback, useContext, useEffect, useState, useImperativeHandle, forwardRef } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { getListCart } from '../../../../controller/api/cart'
import { useCookies } from 'react-cookie'
import { TableRow } from '../component/TableRow'
import { calculatePage } from '../../../../helper/helper'
import Pagination from '../../../../components/Pagination'
import { Context } from '../CartGroup'
import { getListCartGroup } from '../../../../controller/api/cartGroup'

const _Table = forwardRef((props, ref) => {
  const { state } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [data, setData] = useState({})

  const [page, setPage] = useState(0)

  const getAllFunc = useCallback(async () => {
    let phone = state.phone

    const query = {
      phone: phone,
      cartGroupId: state.cartGroupId || undefined,
      gameId: state.gameId,
      status: state.status !== undefined && state.status !== '' ? state.status : undefined,
      createdFrom: state.createdFrom || undefined,
      createdTo: state.createdTo || undefined,
      activatedFrom: state.activatedFrom || undefined,
      activatedTo: state.activatedTo || undefined,
      completedFrom: state.completedFrom || undefined,
      completedTo: state.completedTo || undefined,
      canceledFrom: state.canceledFrom || undefined,
      canceledTo: state.canceledTo || undefined,
      rewardedFrom: state.rewardedFrom || undefined,
      rewardedTo: state.rewardedTo || undefined,
    }

    const response = await getListCartGroup(cookies.lottmekong, query, page)

    if (response) {
      console.log(response)
      const res = {
        list: response.data,
        total: response.total,
        totalPage: calculatePage(response.total)
      }
      setData(res || {})
    }
  }, [cookies.lottmekong, state.createdFrom, state.createdTo, state.activatedFrom, state.activatedTo, state.completedFrom, state.completedTo, state.canceledFrom, state.canceledTo, state.rewardedFrom, state.rewardedTo, state.phone, state.cartGroupId, state.gameId, state.status, page])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc, page])

  useImperativeHandle(ref, () => ({
    refresh: () => {
      getAllFunc()
    }
  }))

  console.log(data)

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">Thao tác</th>
              <th scope="col">Nhóm</th>
              <th scope="col">Trò chơi</th>
              <th scope="col">Hạn chót</th>
              <th scope="col">Người tạo</th>
              <th scope="col">Giá trị</th>
              {(state.status === 4 || state.status === 'completed') && <th scope="col">Giải thưởng</th>}
              <th scope="col">Trạng thái</th>
              <th scope="col">Thời gian</th>
            </tr>
          </thead>
          <tbody>
            {data.list && data.list.map((pv, index) => (
              <TableRow
                rIndex={index}
                key={`table-keys-lottmekong-${pv.id}`}
                {...pv}
                onRefresh={getAllFunc}
                pageStatus={state.status}
              />
            ))}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={data.totalPage || 0}
                currentPage={page || 0}
                onPageChange={(i) => {
                  setPage(i)
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
});

export default React.memo(_Table)